// extracted by mini-css-extract-plugin
module.exports = {"overview":"index_overview_1xRCZ"};